<template>
  <div>
    <Head title="Payment Requests" />
    <h1 class="mb-8 text-3xl font-bold">Payment Requests</h1>
    <!--
    <pre>{{ user.group_permissions }}</pre>
    <pre>{{ user.per_user_permissions }}</pre>
    -->
    <div class="flex items-center justify-between mb-6 mt-6 overflow-x-auto float-right">
      <a
        v-if="
          user.group_permissions.includes('create_payment_requisition') ||
          user.per_user_permissions.includes('create_payment_requisition') ||
          user.per_user_permissions.includes('view_initiated_payment_requisitions') ||
          user.group_permissions.includes('view_initiated_payment_requisitions')
        "
        class="btn-orange float-right mr-1"
        href="#"
        @click="openSearchPr"
      >
        <!--
        <span>Create</span>
        <span class="hidden md:inline">&nbsp;New</span> -->
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          stroke-width="1.5"
          stroke="currentColor"
          class="w-6 h-6"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            d="M21 21l-5.197-5.197m0 0A7.5 7.5 0 105.196 5.196a7.5 7.5 0 0010.607 10.607z"
          />
        </svg>
      </a>
      <a
        v-if="
          user.group_permissions.includes('create_payment_requisition') ||
          user.per_user_permissions.includes('create_payment_requisition') ||
          user.per_user_permissions.includes('view_initiated_payment_requisitions') ||
          user.group_permissions.includes('view_initiated_payment_requisitions')
        "
        class="btn-orange float-right ml-1"
        href="#/initiated-payment-request"
        @click="openCreateNewPrWindow"
      >
        <!--
        <span>Create</span>
        <span class="hidden md:inline">&nbsp;New</span> -->
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          stroke-width="1.5"
          stroke="currentColor"
          class="w-6 h-6 inline"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            d="M12 4.5v15m7.5-7.5h-15"
          />
        </svg>
      </a>
    </div>
    <div class="flex items-center w-full mb-6 mt-6 overflow-x-auto">
      <div
        v-if="
          user.group_permissions.includes('create_payment_requisition') ||
          user.per_user_permissions.includes('create_payment_requisition') ||
          user.per_user_permissions.includes('view_initiated_payment_requisitions') ||
          user.group_permissions.includes('view_initiated_payment_requisitions')
        "
        class="w-1/4 p-5"
      >
        <div class="rounded-lg shadow-lg bg-white max-w-sm w-full">
          <div class="p-6 w-full">
            <Link href="/initiated-payment-request">
              <h5 class="text-gray-900 text-base font-medium mb-2">
                Created <span class="float-right">{{ initiated.items }}</span>
              </h5>
              <h5 v-show="false" class="text-gray-600 text-base font-medium mb-4">
                <span>{{ initiated.total }}</span>
              </h5>
            </Link>
          </div>
        </div>
      </div>
      <div
        v-if="
          user.group_permissions.includes('create_payment_requisition') ||
          user.per_user_permissions.includes('create_payment_requisition') ||
          user.per_user_permissions.includes('view_initiated_payment_requisitions') ||
          user.group_permissions.includes('view_initiated_payment_requisitions') ||
          user.per_user_permissions.includes('approve_payment_requisition') ||
          user.group_permissions.includes('approve_payment_requisition')
        "
        class="w-1/4 p-5"
      >
        <div class="rounded-lg shadow-lg bg-white max-w-sm">
          <div class="p-6">
            <a href="/requested-payment-request">
              <h5 class="text-gray-900 text-base font-medium mb-2">
                Requested <span class="float-right">{{ requested.items }}</span>
              </h5>
              <h5 v-show="false" class="text-gray-600 text-base font-medium mb-4">
                <span>{{ requested.total }}</span>
              </h5>
            </a>
          </div>
        </div>
      </div>
      <div
        v-if="
          user.group_permissions.includes('create_payment_requisition') ||
          user.per_user_permissions.includes('create_payment_requisition') ||
          user.per_user_permissions.includes('approve_payment_requisition') ||
          user.group_permissions.includes('approve_payment_requisition') ||
          user.per_user_permissions.includes('view_initiated_payment_requisitions') ||
          user.group_permissions.includes('view_initiated_payment_requisitions') ||
          user.group_permissions.includes('schedule_payment_requisition') ||
          user.per_user_permissions.includes('schedule_payment_requisition') ||
          user.group_permissions.includes('mark_payment_requisition_as_paid') ||
          user.per_user_permissions.includes('mark_payment_requisition_as_paid')
        "
        class="w-1/4 p-5"
      >
        <div class="rounded-lg shadow-lg bg-white max-w-sm">
          <div class="p-6">
            <a href="/approved-payment-request">
              <h5 class="text-gray-900 text-base font-medium mb-2">
                Approved <span class="float-right">{{ approved.items }}</span>
              </h5>
              <h5 v-show="false" class="text-gray-600 text-base font-medium mb-4">
                <span>{{ approved.total }}</span>
              </h5>
            </a>
          </div>
        </div>
      </div>
      <div
        v-if="
          user.group_permissions.includes('create_payment_requisition') ||
          user.per_user_permissions.includes('create_payment_requisition') ||
          user.per_user_permissions.includes('approve_payment_requisition') ||
          user.group_permissions.includes('approve_payment_requisition') ||
          user.per_user_permissions.includes('view_initiated_payment_requisitions') ||
          user.group_permissions.includes('view_initiated_payment_requisitions') ||
          user.group_permissions.includes('schedule_payment_requisition') ||
          user.per_user_permissions.includes('schedule_payment_requisition') ||
          user.per_user_permissions.includes('reject_payment_requisition') ||
          user.group_permissions.includes('reject_payment_requisition')
        "
        class="w-1/4 p-5"
      >
        <div class="rounded-lg shadow-lg bg-white max-w-sm">
          <div class="p-6">
            <a href="/declined-payment-request">
              <h5 class="text-gray-900 text-base font-medium mb-2">
                Declined  <span class="float-right">{{ declined.items }}</span>
              </h5>
              <h5 v-show="false" class="text-gray-600 text-base font-medium mb-4">
                <span>{{ declined.total }}</span>
              </h5>
            </a>
          </div>
        </div>
      </div>
    </div>
    <div class="flex items-center w-full mb-6 mt-6 overflow-x-auto">
      <div
        v-if="
          user.group_permissions.includes('create_payment_requisition') ||
          user.per_user_permissions.includes('create_payment_requisition') ||
          user.per_user_permissions.includes('approve_payment_requisition') ||
          user.group_permissions.includes('approve_payment_requisition') ||
          user.per_user_permissions.includes('view_initiated_payment_requisitions') ||
          user.group_permissions.includes('view_initiated_payment_requisitions') ||
          user.per_user_permissions.includes('schedule_payment_requisition') ||
          user.group_permissions.includes('schedule_payment_requisition') ||
          user.per_user_permissions.includes('mark_payment_requisition_as_paid') ||
          user.group_permissions.includes('mark_payment_requisition_as_paid')
        "
        class="w-1/4 p-5"
      >
        <div class="rounded-lg shadow-lg bg-white max-w-sm">
          <div class="p-6">
            <a href="/posted-payment-request">
              <h5 class="text-gray-900 text-base font-medium mb-2">
                Bill Posted <span class="float-right">{{ posted.items }}</span>
              </h5>
              <h5 v-show="false" class="text-gray-600 text-base font-medium mb-4">
                <span>{{ posted.total }}</span>
              </h5>
            </a>
          </div>
        </div>
      </div>

      <div
        v-if="
          user.group_permissions.includes('create_payment_requisition') ||
          user.per_user_permissions.includes('create_payment_requisition') ||
          user.per_user_permissions.includes('approve_payment_requisition') ||
          user.group_permissions.includes('approve_payment_requisition') ||
          user.per_user_permissions.includes('view_initiated_payment_requisitions') ||
          user.group_permissions.includes('view_initiated_payment_requisitions') ||
          user.per_user_permissions.includes('schedule_payment_requisition') ||
          user.group_permissions.includes('schedule_payment_requisition') ||
          user.per_user_permissions.includes('mark_payment_requisition_as_paid') ||
          user.group_permissions.includes('mark_payment_requisition_as_paid')
        "
        class="w-1/4 p-5"
      >
        <div class="rounded-lg shadow-lg bg-white max-w-sm">
          <div class="p-6">
            <a href="/scheduled-payment-request">
              <h5 class="text-gray-900 text-base font-medium mb-2">
                Scheduled For Payment <span class="float-right">{{ scheduled.items }}</span>
              </h5>
              <h5 v-show="false" class="text-gray-600 text-base font-medium mb-4">
                <span>{{ scheduled.total }}</span>
              </h5>
            </a>
          </div>
        </div>
      </div>
      <div
        v-if="
          user.group_permissions.includes('create_payment_requisition') ||
          user.per_user_permissions.includes('create_payment_requisition') ||
          user.per_user_permissions.includes('approve_payment_requisition') ||
          user.group_permissions.includes('approve_payment_requisition') ||
          user.per_user_permissions.includes('view_initiated_payment_requisitions') ||
          user.group_permissions.includes('view_initiated_payment_requisitions') ||
          user.per_user_permissions.includes('schedule_payment_requisition') ||
          user.group_permissions.includes('schedule_payment_requisition') ||
          user.per_user_permissions.includes('mark_payment_requisition_as_paid') ||
          user.group_permissions.includes('mark_payment_requisition_as_paid')
        "
        class="w-1/4 p-5"
      >
        <div class="rounded-lg shadow-lg bg-white max-w-sm">
          <div class="p-6">
            <a href="/declined-payments">
              <h5 class="text-gray-900 text-base font-medium mb-2">
                Payment Declined
                <span class="float-right">{{ declinedPayments.items }}</span>
              </h5>
              <h5 v-show="false" class="text-gray-600 text-base font-medium mb-4">
                <span>{{ declinedPayments.total }}</span>
              </h5>
            </a>
          </div>
        </div>
      </div>
      <div
        v-if="
          user.group_permissions.includes('create_payment_requisition') ||
          user.per_user_permissions.includes('create_payment_requisition') ||
          user.per_user_permissions.includes('approve_payment_requisition') ||
          user.group_permissions.includes('approve_payment_requisition') ||
          user.per_user_permissions.includes('view_initiated_payment_requisitions') ||
          user.group_permissions.includes('view_initiated_payment_requisitions') ||
          user.per_user_permissions.includes('schedule_payment_requisition') ||
          user.group_permissions.includes('schedule_payment_requisition') ||
          user.per_user_permissions.includes('mark_payment_requisition_as_paid') ||
          user.group_permissions.includes('mark_payment_requisition_as_paid')
        "
        class="w-1/4 p-5"
      >
        <div class="rounded-lg shadow-lg bg-white max-w-sm">
          <div class="p-6">
            <a href="/paid-payment-request">
              <h5 class="text-gray-900 text-base font-medium mb-2">
                Paid <span class="float-right">{{ paid.items }}</span>
              </h5>
              <h5 v-show="false" class="text-gray-600 text-base font-medium mb-4">
                <span>{{ paid.total }}</span>
              </h5>
            </a>
          </div>
        </div>
      </div>

      <div
        v-show="false"
        v-if="
          user.group_permissions.includes('create_payment_requisition') ||
          user.per_user_permissions.includes('create_payment_requisition') ||
          user.per_user_permissions.includes('approve_payment_requisition') ||
          user.group_permissions.includes('approve_payment_requisition') ||
          user.per_user_permissions.includes('view_initiated_payment_requisitions') ||
          user.group_permissions.includes('view_initiated_payment_requisitions') ||
          user.per_user_permissions.includes('schedule_payment_requisition') ||
          user.group_permissions.includes('schedule_payment_requisition') ||
          user.per_user_permissions.includes('mark_payment_requisition_as_paid') ||
          user.group_permissions.includes('mark_payment_requisition_as_paid')
        "
        class="w-1/4 p-5"
      >
        <div class="rounded-lg shadow-lg bg-white max-w-sm">
          <div class="p-6">
            <a href="/canceled-payment-request">
              <h5 class="text-gray-900 text-base font-medium mb-2">
                Canceled PRs
                <span class="float-right">{{ canceled.items }}</span>
              </h5>
              <h5 v-show="false" class="text-gray-600 text-base font-medium mb-4">
                <span>{{ canceled.total }}</span>
              </h5>
            </a>
          </div>
        </div>
      </div>
    </div>

    <div class="flex items-center w-full mb-6 mt-6 overflow-x-auto">
      <div
        v-if="
          user.group_permissions.includes('create_payment_requisition') ||
          user.per_user_permissions.includes('create_payment_requisition') ||
          user.per_user_permissions.includes('approve_payment_requisition') ||
          user.group_permissions.includes('approve_payment_requisition') ||
          user.per_user_permissions.includes('view_initiated_payment_requisitions') ||
          user.group_permissions.includes('view_initiated_payment_requisitions') ||
          user.per_user_permissions.includes('schedule_payment_requisition') ||
          user.group_permissions.includes('schedule_payment_requisition') ||
          user.per_user_permissions.includes('mark_payment_requisition_as_paid') ||
          user.group_permissions.includes('mark_payment_requisition_as_paid')
        "
        class="w-1/4 p-5"
      >
        <div class="rounded-lg shadow-lg bg-white max-w-sm">
          <div class="p-6">
            <a href="/schedule-prepaid-payment-request">
              <h5 class="text-gray-900 text-base font-medium mb-2">
                Scheduled for Prepayment <span class="float-right">{{ schedulePrepaid.items }}</span>
              </h5>
              <h5 v-show="false" class="text-gray-600 text-base font-medium mb-4">
                <span>{{ schedulePrepaid.total }}</span>
              </h5>
            </a>
          </div>
        </div>
      </div>
      <div
        v-if="
          user.group_permissions.includes('create_payment_requisition') ||
          user.per_user_permissions.includes('create_payment_requisition') ||
          user.per_user_permissions.includes('approve_payment_requisition') ||
          user.group_permissions.includes('approve_payment_requisition') ||
          user.per_user_permissions.includes('view_initiated_payment_requisitions') ||
          user.group_permissions.includes('view_initiated_payment_requisitions') ||
          user.per_user_permissions.includes('schedule_payment_requisition') ||
          user.group_permissions.includes('schedule_payment_requisition') ||
          user.per_user_permissions.includes('mark_payment_requisition_as_paid') ||
          user.group_permissions.includes('mark_payment_requisition_as_paid')
        "
        class="w-1/4 p-5"
      >
        <div class="rounded-lg shadow-lg bg-white max-w-sm">
          <div class="p-6">
            <a href="/prepaid-payment-request">
              <h5 class="text-gray-900 text-base font-medium mb-2">
                Prepaid <span class="float-right">{{ prepaid.items }}</span>
              </h5>
              <h5 v-show="false" class="text-gray-600 text-base font-medium mb-4">
                <span>{{ prepaid.total }}</span>
              </h5>
            </a>
          </div>
        </div>
      </div>
      <div
        v-if="
          user.group_permissions.includes('create_payment_requisition') ||
          user.per_user_permissions.includes('create_payment_requisition') ||
          user.per_user_permissions.includes('approve_payment_requisition') ||
          user.group_permissions.includes('approve_payment_requisition') ||
          user.per_user_permissions.includes('view_initiated_payment_requisitions') ||
          user.group_permissions.includes('view_initiated_payment_requisitions') ||
          user.per_user_permissions.includes('schedule_payment_requisition') ||
          user.group_permissions.includes('schedule_payment_requisition') ||
          user.per_user_permissions.includes('mark_payment_requisition_as_paid') ||
          user.group_permissions.includes('mark_payment_requisition_as_paid')
        "
        class="w-1/4 p-5"
      >
        <div class="rounded-lg shadow-lg bg-white max-w-sm">
          <div class="p-6">
            <a href="/post-prepaid-payment-request">
              <h5 class="text-gray-900 text-base font-medium mb-2">
                Prepayment Bill Posted <span class="float-right">{{ postPrepaid.items }}</span>
              </h5>
              <h5 v-show="false" class="text-gray-600 text-base font-medium mb-4">
                <span>{{ postPrepaid.total }}</span>
              </h5>
            </a>
          </div>
        </div>
      </div>
      <div
        v-if="
          user.group_permissions.includes('create_payment_requisition') ||
          user.per_user_permissions.includes('create_payment_requisition') ||
          user.per_user_permissions.includes('approve_payment_requisition') ||
          user.group_permissions.includes('approve_payment_requisition') ||
          user.per_user_permissions.includes('view_initiated_payment_requisitions') ||
          user.group_permissions.includes('view_initiated_payment_requisitions') ||
          user.per_user_permissions.includes('schedule_payment_requisition') ||
          user.group_permissions.includes('schedule_payment_requisition') ||
          user.per_user_permissions.includes('mark_payment_requisition_as_paid') ||
          user.group_permissions.includes('mark_payment_requisition_as_paid')
        "
        class="w-1/4 p-5"
      >
        <div class="rounded-lg shadow-lg bg-white max-w-sm">
          <div class="p-6">
            <a href="/todays-scheduled-payment-request">
              <h5 class="text-gray-900 text-base font-medium mb-2">
                Overdue<span class="float-right">{{ scheduled.items }}</span>
              </h5>
              <h5 v-show="false" class="text-gray-600 text-base font-medium mb-4">
                <span>{{ todays.total }}</span>
              </h5>
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div v-if="isSearchPr" class="fixed z-10 inset-0 overflow-y-auto">
    <div
      class="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0"
    >
      <div class="fixed inset-0 transition-opacity">
        <div class="absolute inset-0 bg-gray-500 opacity-75" />
      </div>
      <!-- This element is to trick the browser into centering the modal contents. -->
      <span class="hidden sm:inline-block sm:align-middle sm:h-screen" />
      <div
        class="inline-block align-bottom w-3/4 bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-top"
        role="dialog"
        aria-modal="true"
        aria-labelledby="modal-headline"
      >
        <form>
          <div class="bg-gray-50 px-4 py-3 sm:px-6 sm:flex modal-wrapper">
            <h1 style="font-size: 24px">Payment Requests</h1>
          </div>
          <div class="bg-white px-4 pt-0 pb-4 sm:p-6 sm:pb-4">
            <div class="mb-4">
              <div class="flex items-center justify-between mb-6">
                <search-filter
                  v-model="form.search"
                  class="mr-4 w-full max-w-md"
                  @reset="reset"
                />
              </div>
            </div>
            <div class="mb-4">
              <div class="bg-white rounded-md shadow overflow-x-auto">
                <table class="w-full whitespace-nowrap">
                  <tr class="text-left font-bold">
                    <th class="pb-3 pt-3 px-2">Date</th>
                    <th class="pb-3 pt-3 px-2">PR Number</th>
                    <th class="pb-3 pt-3 px-2">Supplier Name</th>
                    <th class="pb-3 pt-3 px-2 text-end">Amount</th>
                    <th class="pb-3 pt-3 px-2">Currency</th>
                    <th class="pb-3 pt-3 px-2">Requested By</th>
                    <th class="pb-3 pt-3 px-2">Department</th>
                    <th class="pb-3 pt-3 px-2" colspan="2">Status</th>
                  </tr>
                  <tr
                    v-for="pr in paymentRequests.data"
                    :key="pr.id"
                    class="hover:bg-orange-100 focus-within:bg-gray-100"
                  >
                    <td class="border-t">
                      <a
                        class="flex items-center px-2 py-2 focus:text-indigo-500"
                        :href="`/payment-requests/${pr.id}/payment-request-details`"
                      >
                        {{ pr.date }}
                      </a>
                    </td>
                    <td class="border-t">
                      <a
                        class="flex items-center px-2 py-2"
                        :href="`/payment-request/${pr.id}/payment-request-details`"
                        tabindex="-1"
                      >
                        {{ pr.pr_number }}
                      </a>
                    </td>
                    <td class="border-t">
                      <a
                        class="flex items-center px-2 py-2"
                        :href="`/payment-request/${pr.id}/payment-request-details`"
                        tabindex="-1"
                      >
                        {{ pr.supplier }}
                      </a>
                    </td>
                    <td class="border-t">
                      <a
                        class="flex items-center justify-center px-2 py-2"
                        :href="`/payment-request/${pr.id}/payment-request-details`"
                        tabindex="-1"
                      >
                        {{ pr.total }}
                      </a>
                    </td>
                    <td class="border-t">
                      <a
                        class="flex items-center px-2 py-2"
                        :href="`/payment-request/${pr.id}/payment-request-details`"
                        tabindex="-1"
                      >
                        {{ pr.currency }}
                      </a>
                    </td>
                    <td class="border-t">
                      <a
                        class="flex items-center px-2 py-2"
                        :href="`/payment-request/${pr.id}/payment-request-details`"
                        tabindex="-1"
                      >
                        {{ pr.user }}
                      </a>
                    </td>
                    <td class="border-t">
                      <a
                        class="flex items-center px-2 py-2"
                        :href="`/payment-request/${pr.id}/payment-request-details`"
                        tabindex="-1"
                      >
                        {{ pr.department }}
                      </a>
                    </td>
                    <td class="border-t">
                      <a
                        class="flex items-center px-2 py-2"
                        :href="`/payment-request/${pr.id}/payment-request-details`"
                        tabindex="-1"
                      >
                        {{ pr.status }}
                      </a>
                    </td>
                    <td class="w-px border-t">
                      <a
                        class="flex items-center px-4 hidden"
                        :href="`/payment-request/${pr.id}/payment-request-details`"
                        tabindex="-1"
                      >
                        <icon name="cheveron-right" class="block w-6 h-6 fill-gray-400" />
                      </a>
                    </td>
                  </tr>
                  <tr v-if="paymentRequests.data.length === 0">
                    <td class="px-3 py-3 border-t" colspan="8">No data found</td>
                  </tr>
                </table>
              </div>
              <pagination class="mt-6" :links="paymentRequests.links" />
            </div>
          </div>
          <div class="bg-gray-50 px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse">
            <span class="mt-3 flex w-full rounded-md shadow-sm sm:mt-0 sm:w-auto">
              <button
                type="button"
                class="inline-flex justify-center w-full rounded-md border border-gray-300 px-4 py-2 bg-white text-base leading-6 font-medium text-gray-700 shadow-sm hover:text-gray-500 focus:outline-none focus:border-blue-300 focus:shadow-outline-blue sm:text-sm sm:leading-5"
                @click="closeSearchPR"
              >
                Close
              </button>
            </span>
          </div>
        </form>
      </div>
    </div>
  </div>
  <div v-if="isCreatePrWindowOpen" class="fixed z-10 inset-0 overflow-y-auto">
    <div
      class="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0"
    >
      <div class="fixed inset-0 transition-opacity">
        <div class="absolute inset-0 bg-gray-500 opacity-75" />
      </div>
      <!-- This element is to trick the browser into centering the modal contents. -->
      <span class="hidden sm:inline-block sm:align-middle sm:h-screen" />
      <div
        class="inline-block align-bottom bg-white rounded-lg text-left w-1/2 overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle"
        role="dialog"
        aria-modal="true"
        aria-labelledby="modal-headline"
      >
        <form>
          <div class="bg-gray-50 px-4 py-3 sm:px-6 sm:flex modal-wrapper">
            <h1 style="font-size: 24px">New Payment Request</h1>
          </div>
          <div class="bg-white px-4 pt-0 pb-4 sm:p-6 sm:pb-4">
            <div class="flex flex-wrap -mb-8 -mr-6 p-8">
              <div class="pb-8 pr-6 w w-full lg:w-full">
                <p class="mb-2">Supplier:</p>
                <multiselect
                  id="supplier"
                  v-model="selectedSupplier"
                  placeholder="Search Supplier"
                  :options="suppliers"
                  :close-on-select="true"
                  :searchable="true"
                  @search-change="onSearchSuppliersChange"
                  @input="onSelectedSupplier"
                />
                <p v-if="$props.errors.supplier">
                  <small class="text-red-700">{{ $props.errors.supplier }}</small>
                </p>
              </div>
              <div class="pb-8 pr-6 w w-full lg:w-full">
                <p class="mb-2">Department:</p>
                <multiselect
                  id="department"
                  v-model="selectedDepartment"
                  placeholder="Search Department"
                  :options="departments"
                  :close-on-select="true"
                  :searchable="true"
                  @search-change="onSearchDepartmentsChange"
                  @input="onSelectedDepartment"
                />
                <p v-if="$props.errors.department">
                  <small class="text-red-700">{{ $props.errors.department }}</small>
                </p>
              </div>
              <div class="pb-8 pr-6 w w-full lg:w-full">
                <p class="mb-2">Currency:</p>
                <multiselect
                  id="currency"
                  v-model="selectedCurrency"
                  placeholder="Search Currency"
                  :options="currencies"
                  :close-on-select="true"
                  :searchable="true"
                  @search-change="onSearchCurrencyChange"
                  @input="onSelectedCurrency"
                />
                <p v-if="$props.errors.currency">
                  <small class="text-red-700">{{ $props.errors.currency }}</small>
                </p>
              </div>
            </div>
          </div>
          <div class="bg-gray-50 px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse">
            <span class="flex w-full rounded-md shadow-sm sm:ml-3 sm:w-auto">
              <button
                v-if="
                  user.group_permissions.includes('create_payment_requisition') ||
                  user.per_user_permissions.includes('create_payment_requisition') ||
                  user.per_user_permissions.includes('create_global_payment_requisition')
                "
                type="button"
                class="inline-flex justify-center w-full rounded-md border border-transparent px-4 py-2 bg-green-600 text-base leading-6 font-medium text-white shadow-sm hover:bg-green-500 focus:outline-none focus:border-green-700 focus:shadow-outline-red sm:text-sm sm:leading-5"
                @click="submitNewPR"
              >
                Save
              </button>
            </span>
            <span class="mt-3 flex w-full rounded-md shadow-sm sm:mt-0 sm:w-auto">
              <button
                type="button"
                class="inline-flex justify-center w-full rounded-md border border-gray-300 px-4 py-2 bg-white text-base leading-6 font-medium text-gray-700 shadow-sm hover:text-gray-500 focus:outline-none focus:border-blue-300 focus:shadow-outline-blue sm:text-sm sm:leading-5"
                @click="closeOpenPR"
              >
                Cancel
              </button>
            </span>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import { Head, Link } from "@inertiajs/inertia-vue3";
import Icon from "@/Shared/Icon";
import Layout from "@/Shared/Layout";
import Multiselect from "@vueform/multiselect";
import SearchFilter from "@/Shared/SearchFilter";
import pickBy from "lodash/pickBy";
import throttle from "lodash/throttle";
import Pagination from "@/Shared/Pagination";
import mapValues from "lodash/mapValues";

export default {
  components: {
    Head,
    Icon,
    Link,
    Multiselect,
    SearchFilter,
    Pagination,
  },
  layout: Layout,
  props: {
    initiated: Number,
    requested: Number,
    approved: Number,
    declined: Number,
    scheduled: Number,
    declinedPayments: Number,
    paid: Number,
    todays: Number,
    posted: Number,
    prepaid: Number,
    schedulePrepaid: Number,
    canceled: Number,
    postPrepaid: Number,
    suppliers: Object,
    departments: Object,
    currencies: Array,
    errors: Object,
    filters: Object,
    paymentRequests: Object,
  },
  data() {
    return {
      search: null,
      isCreatePrOpen: false,
      isCreatePrWindowOpen: false,
      isSearchPr: false,
      show: false,
      formData: {
        supplier: null,
        department: null,
        currency: null,
      },
      form: {
        search: this.filters.search,
      },
    };
  },
  computed: {
    user() {
      return this.$inertia.page.props.auth.user;
    },
  },
  watch: {
    form: {
      deep: true,
      handler: throttle(function () {
        this.$inertia.get("/payment-requests", pickBy(this.form), {
          preserveState: true,
        });
      }, 150),
    },
  },
  methods: {
    reset() {
      this.form = mapValues(this.form, () => null);
    },
    openCreateNewPr() {
      this.isCreatePrOpen = true;
    },
    closeOpenPR() {
      this.isCreatePrOpen = false;
      this.isCreatePrWindowOpen = false;
      this.$props.errors.supplier = "";
      this.$props.errors.department = "";
      this.show = false;
    },
    openCreateNewPrWindow() {
      this.isCreatePrWindowOpen = true;
    },
    openSearchPr() {
      this.isSearchPr = true;
    },
    closeSearchPR() {
      this.isSearchPr = false;
    },
    submitNewPR() {
      const prInt = 0;
      this.$inertia.post("/payment-requests", this.formData, {
        onSuccess: () => {
          this.isCreatePrOpen = false;
          setTimeout(function () {
            this.show = false;
          }, 1000);
          this.$router.push(`/payment-request/${prInt}/payment-request-details`);
        },
        onFail: () => {
          setTimeout(function () {
            this.show = false;
          }, 1000);
        },
      });
    },
    onSelectedSupplier(supplier, id) {
      this.formData.supplier = supplier;
    },
    onSelectedDepartment(department, id) {
      this.formData.department = department;
    },
    onSelectedCurrency(currency, id) {
      this.formData.currency = currency;
    },
  },
};
</script>
<style src="@vueform/multiselect/themes/default.css"></style>
<style type="text/css">
.multiselect-option.is-selected.is-pointed {
  background: var(--ms-option-bg-selected-pointed, #fb923c);
  color: var(--ms-option-color-selected-pointed, #fff);
}
.multiselect-option.is-selected {
  background: var(--ms-option-bg-selected-pointed, #fb923c);
  color: var(--ms-option-color-selected-pointed, #fff);
}
</style>
